<template>
  <div :class="`d-flex task-card-item ${taskItemBorderColor}`" pt="0.5" pb="0.5" pr="0.5" mt="0.5" mb="0.5">
    <div class="flex-grow-1 task-card-item__title" ml=1>
      {{ taskData.title }}
    </div>
    <div ml="0.5" class="d-flex">
      <template v-if="!taskData.archived">
        <span class="task-card-item__actions__circle" v-if="isStopped || isPaused" @click="play()" :title="$t('start')"><i class="bi bi-play-fill"></i></span>
        <span class="task-card-item__actions__circle" v-else-if="isPlayed" @click="pause()" :title="$t('pause')"><i class="bi bi-pause-fill"></i></span>
        <span class="task-card-item__actions__circle" v-else-if="isTimeUp" @click="restart()" :title="$t('restart')"><i class="bi bi-arrow-counterclockwise"></i></span>
      </template>
      <vue-admin-tasks-task-card-menu :taskData="taskData">
        <template v-slot:wrapper>
          <span class="task-card-item__actions" ml="0.5"><i class="bi bi-three-dots-vertical"></i></span>
        </template>
      </vue-admin-tasks-task-card-menu>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';

  export default{
    props: {
      taskData: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('taskStoreModule', ['playTask', 'pauseTask', 'stopTask', 'timesUpTask']),
      play(){
        this.playTask({task_id: this.taskData["id"]})
      },
      pause(){
        this.pauseTask({task_id: this.taskData["id"]});
      },
      stop(){
        his.stopTask({task_id: this.taskData["id"]});
      },
      timesUp(){
        this.timesUpTask({task_id: this.taskData["id"]});
      },
      restart(){
        this.stopTask({task_id: this.taskData["id"]});
      },
    },
    computed: {
      timerState(){
        return this.taskData["timerState"]
      },
      isTimeUp(){
        return this.timerState==3;
      },
      isStopped(){
        return this.timerState==0;
      },
      isPlayed(){
        return this.timerState==1;
      },
      isPaused(){
        return this.timerState==2;
      },
      taskItemBorderColor(){
        if(this.taskData.archived){
          return 'task-card-item-danger'
        }
        switch(this.timerState){
          case 0:
            return 'task-card-item-gray';
          case 1:
            return 'task-card-item-primary';
          case 2:
            return 'task-card-item-warning';
          case 3:
            return 'task-card-item-success';
        }
      }
    },
    i18n: {
      messages:{
        "pt-BR": {
          start: 'Iniciar',
          pause: 'Pausar',
          restart: 'Reiniciar'
        },
        en: {
          start: 'Start',
          pause: 'Pause',
          restart: 'Restart'
        }
      }
    }
  }
</script>
